import { isObject } from 'lodash';

function setDeepValue(state, keyString, value) {
    if (keyString.indexOf('.') > -1) {
        setDeepValue(state[keyString.split('.')[0]], keyString.split('.')[1], value);
    } else {
        state[keyString] = value;
    }
}

function setTargetValue(state, keyString, value) {
    if (keyString.indexOf('.') > -1) {
        setDeepValue(state, keyString, value);
    } else {
        state[keyString] = value;
    }
}

export default {
    SET_STATE(state, payload) {
        if (isObject(payload)) {
            for (const key in payload) {
                setTargetValue(state, key, payload[key]);
            }
        } else {
            throw new Error('payload must be Object');
        }
    }
};
